import axios from 'axios'
import { usePage } from '@inertiajs/vue3'

function currentUser () {
  if (window.currentUser === undefined || window.currentUser === null || window.currentUser?.permissions === undefined || window.currentUser?.permissions === null) {
    window.currentUser = usePage()?.props?.current_user?.data ?? null
    if (window.currentUser === null) {
      axios.get(route('auth.permissions')).then(response => {
        window.currentUser = response.data.data
      })
    }
  }
  return window.currentUser
}

function can (permission) {
  const permissions = currentUser()?.permissions || []
  return permissions.includes(permission)
}

export default {
  methods: {
    $can: can,
  },
}

export {
  currentUser, can,
}
